import { Component } from '@angular/core';

@Component({
  selector: 'app-ds-card-title',
  templateUrl: './ds-card-title.component.html',
  styleUrls: ['./ds-card-title.component.scss']
})
export class DsCardTitleComponent {}
